import { Api } from './generated/v2/generated/Api';

/**
 * This instance contains methods to make all calls to the time-for-teams backend.
 */
export const ApiCallsV2 = new Api<() => Promise<string>>({
    securityWorker: async (getAccessTokenFunction?: () => Promise<string>) => {
        if (getAccessTokenFunction) {
            const response = await getAccessTokenFunction();

            const headers = {
                Authorization: `Bearer ${response}`,
                Accept: 'application/json',
            };

            return { headers };
        }
        return {};
    },
});
